/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';

import {
  Container,
  Grid,
  Typography,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Button,
  Box,
  Stack,
  Divider,
} from '@mui/material';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import ReactPlaceholder from 'react-placeholder/lib';
import { connect } from 'react-redux';
import { Breadcrumbs } from 'wae_rwlb_reactlibrary';

import { getQuotationData } from '../../../actions';
import { COLOR } from '../../../helpers/colors';
import { breadcrumbNameMap } from '../../../helpers/config';
import { formatAmount } from '../../../helpers/functions';
import QuotationDetailsPlaceholder from '../QuotationDetailsPlaceholder';
import { styles } from './styles';

const RenderQuotationDetails = props => {
  const { quotations, t } = props;
  const { selQuotationDetailData } = quotations;

  return (
    <Grid>
      <Grid
        sx={{
          border: `1px solid ${COLOR.borderColor}`,
          borderBottomLeftRadius: 5,
          borderBottomRightRadius: 5,
          marginTop: 2,
        }}
      >
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          sx={{
            background: COLOR.textColor,
            color: COLOR.whiteTextColor,
            p: 3,
            textTransform: 'uppercase',
            borderTopLeftRadius: 5,
            borderTopRightRadius: 5,
          }}
        >
          <Typography>ID: {selQuotationDetailData.SalesQuotation}</Typography>
          <Typography
            sx={{
              fontSize: 14,
            }}
          >
            {t('quotationScreenTranslations:TOTAL_NET_VALUE')}:{' '}
            <span style={{ fontWeight: 'bold' }}>
              {formatAmount(
                'en-AE',
                selQuotationDetailData.TotalNetValue,
                selQuotationDetailData.TransactionCurrency
              )}
            </span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          direction="row"
          justifyContent="space-between"
          sx={{ paddingY: 2, paddingX: 1, background: COLOR.bgColor }}
        >
          <Grid>
            <Typography sx={styles.statusLabelText}>
              {t('quotationScreenTranslations:OVERALL_STATUS')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selQuotationDetailData.OverallSDProcessStatus}
              </span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              Process Status:{' '}
              <span style={{ fontWeight: 'bold' }}>{selQuotationDetailData.ProcessStatusText}</span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              Distribution Channel Name:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selQuotationDetailData.DistributionChannelName}
              </span>
            </Typography>
          </Grid>
          <Grid>
            <Typography sx={styles.statusLabelText}>
              Sales Quotation:{' '}
              <span style={{ fontWeight: 'bold' }}>{selQuotationDetailData.SalesQuotation}</span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              Sales Quotation Type:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selQuotationDetailData.SalesQuotationType}
              </span>
            </Typography>

            {selQuotationDetailData && selQuotationDetailData === 'Blocked' ? (
              <Typography
                sx={{
                  paddingY: 0.5,
                  paddingX: 1,
                  fontSize: 14,
                }}
              >
                {t('quotationScreenTranslations:DEL_BLOCK_REASON')}:{' '}
                <span style={{ fontWeight: 'bold' }}>
                  {selQuotationDetailData.DeliveryBlockReason || '-'}
                </span>
              </Typography>
            ) : null}
            <Typography sx={styles.statusLabelText}>
              {t('quotationScreenTranslations:EXP_DATE')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {moment(selQuotationDetailData.RequestedDeliveryDate).format('MMMM DD, YYYY') ||
                  '-'}
              </span>
            </Typography>
          </Grid>
          <Grid>
            <Typography sx={styles.statusLabelText}>
              Sales Document Type Name:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {selQuotationDetailData.SalesDocumentTypeName}
              </span>
            </Typography>

            <Typography sx={styles.statusLabelText}>
              Ship To Party:{' '}
              <span style={{ fontWeight: 'bold' }}>{selQuotationDetailData.ShipToParty}</span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              Sold To Party:{' '}
              <span style={{ fontWeight: 'bold' }}>{selQuotationDetailData.SoldToParty}</span>
            </Typography>

            <Typography sx={styles.statusLabelText}>
              Sold To Party Name:{' '}
              <span style={{ fontWeight: 'bold' }}>{selQuotationDetailData.SoldToPartyName}</span>
            </Typography>
            <Typography sx={styles.statusLabelText}>
              {t('quotationScreenTranslations:TOTAL_NET_VALUE')}:{' '}
              <span style={{ fontWeight: 'bold' }}>
                {formatAmount(
                  'en-AE',
                  selQuotationDetailData.TotalNetValue,
                  selQuotationDetailData.TransactionCurrency
                )}
              </span>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      {selQuotationDetailData &&
      selQuotationDetailData.to_QuotationItems &&
      selQuotationDetailData.to_QuotationItems.results.length > 0 ? (
        <>
          <Grid container justifyContent="space-between" alignItems="center" sx={{ mt: 3 }}>
            <Typography sx={{ mb: 1, fontWeight: 600, fontSize: 18 }}>
              {t('quotationScreenTranslations:ITEMS')}
            </Typography>
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead sx={{ borderTop: `1px solid ${COLOR.borderColor}` }}>
                  <TableRow>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Sales Quotation
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      SuperSeeded Part No
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Sales Document Item
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      {t('quotationScreenTranslations:MATERIAL')}
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Description
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Requested Quantity
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Available in WH
                    </TableCell>
                    <TableCell align="left" sx={styles.tableHeadCell}>
                      Unit Price
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selQuotationDetailData.to_QuotationItems.results.map((row, index) => {
                    const {
                      SalesDocument,
                      SalesDocumentItem,
                      Material,
                      MaterialName,
                      OrderQuantity,
                      Stock,
                      NetPriceAmount,
                      TransactionCurrency,
                      ConcatSuperMaterials,
                    } = row;
                    return (
                      <TableRow
                        key={index.toString()}
                        sx={{
                          '&:last-child td, &:last-child th': {
                            border: 0,
                          },
                        }}
                      >
                        <TableCell align="left" sx={{ paddingY: 2, paddingX: 1.5 }}>
                          {SalesDocument}
                        </TableCell>
                        <TableCell align="left" sx={{ paddingY: 2, paddingX: 1.5 }}>
                          {ConcatSuperMaterials}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {SalesDocumentItem}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {Material}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {MaterialName}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {OrderQuantity}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {Stock}
                        </TableCell>
                        <TableCell align="left" sx={styles.tableRowCell}>
                          {formatAmount('en-AE', NetPriceAmount, TransactionCurrency)}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Divider />
        </>
      ) : null}
    </Grid>
  );
};

class QuotationDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    try {
      const { quotationId } = this.props.match.params;
      this.props.getQuotationData(quotationId);
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const { quotations, t } = this.props;
    const { quotationId } = this.props.match.params;
    const { selQuotationDetailData, isQuotationDetailLoading } = quotations;
    return (
      <Container>
        <Breadcrumbs
          {...this.props}
          data={[
            { name: 'Home', path: '/' },
            { name: 'Quotations', path: '/quotations' },
            {
              name:
                selQuotationDetailData && selQuotationDetailData !== null
                  ? selQuotationDetailData.SalesQuotation
                  : '-',
            },
          ]}
          breadcrumbNameMap={breadcrumbNameMap(t)}
        />

        <ReactPlaceholder
          showLoadingAnimation
          ready={!isQuotationDetailLoading}
          customPlaceholder={<QuotationDetailsPlaceholder />}
        >
          {selQuotationDetailData && selQuotationDetailData !== null ? (
            <Box sx={{ marginY: 6 }}>
              <RenderQuotationDetails {...this.props} />
            </Box>
          ) : (
            <Box m={5}>
              <Typography variant="h5" align="center">
                {`${t('quotationScreenTranslations:UNABLE_TO_LOAD')} ${quotationId}`}
              </Typography>
              <Stack flexDirection="row" justifyContent="center">
                <Button
                  variant="text"
                  onClick={() => {
                    this.props.history.push('/quotations');
                  }}
                >
                  {t('quotationScreenTranslations:GO_BACK_TO_QUOTATIONS')}
                </Button>
              </Stack>
            </Box>
          )}
        </ReactPlaceholder>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  return {
    quotations: state.quotations,
  };
};

const cQuotationDetails = connect(mapStateToProps, { getQuotationData })(QuotationDetails);
const tQuotationDetails = withTranslation(['quotationScreenTranslations'])(cQuotationDetails);

export { tQuotationDetails as QuotationDetails };
